/* eslint-disable react/prop-types */
import React from "react";
import OrganizationStructure from "./OrganizationStructure";

const styles = {
  border: "none",
  padding: 0,
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gridTemplateRows: "1fr",
  gridColumnGap: "1.5rem",
  marginBottom: "1rem",
  gridRowGap: "0.2rem",
};

function OrganisationSearch({
  values,
  errors,
  handleChange,
  setFieldValue,
  disabledOSKeys,
  required,
  showArea,
  showDivision,
  showFutureDivision,
  showStudentDivision,
  showSubDivision,
}) {
  return (
    <OrganizationStructure
      values={values}
      errors={errors}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      required={required}
      disabledOSKeys={disabledOSKeys}
      containerStyle={styles}
      showArea={showArea}
      showDivision={showDivision}
      showFutureDivision={showFutureDivision}
      showStudentDivision={showStudentDivision}
      showSubDivision={showSubDivision}
      storeValuesInRedux
    />
  );
}

export default OrganisationSearch;
